import React from 'react';
import { Dropdown } from 'semantic-ui-react';

interface ProjectSelectorProps {
  options: { key: string; value: string; text: string }[];
  value: string;
  loading: boolean;
  onChange: (value: string) => void;
}

export const ProjectSelector: React.FC<ProjectSelectorProps> = ({
  options,
  value,
  loading,
  onChange,
}) => (
  <Dropdown
    placeholder="Select Project Title"
    selection
    search
    clearable
    options={options}
    loading={loading}
    value={value}
    onChange={(_, { value }) => onChange(value as string)}
    style={{ minWidth: '300px' }}
  />
);
